import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useCallback } from "react";
import { E164Number } from "libphonenumber-js/types";
import styles from "./index.module.scss";

export interface PhoneNumberInputChangeEvent {
    target: { value: E164Number; type: "tel"; id: string; checked?: boolean };
    persist?: () => void;
}

export interface PhoneNumberInputProps {
    id: string;
    label: string;
    placeholder: string;
    value: string;
    error?: string;
    help?: string;
    horizontal?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    maxLength?: number;
    readOnly?: boolean;
    location?: "profile-page" | "create-account";
    onChange?: (event: PhoneNumberInputChangeEvent) => void;
}

export const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
    placeholder,
    value,
    label,
    id,
    location = "profile-page",
    readOnly = false,
    onChange,
    error
}) => {
    const _onChange = useCallback(
        (value?: E164Number) => {
            onChange({
                target: {
                    value,
                    id,
                    type: "tel"
                }
            });
        },
        [id, onChange]
    );

    return (
        <div className={`${styles["container"]} ${styles[location]}`}>
            <label
                className={`${styles["floating-label"]} ${styles["has-focus"]}`}
                htmlFor={id}
            >
                {label}
            </label>
            <span className="form-control">
                <PhoneInput
                    id={id}
                    value={value}
                    onChange={_onChange}
                    placeholder={placeholder}
                    disabled={readOnly}
                    defaultCountry="US"
                />
            </span>
            <small
                id={`${id}-help`}
                aria-describedby={id}
                className="form-text"
            >
                {error && (
                    <div className="alert alert-danger alert-info mb-0 p-2">
                        {error}
                    </div>
                )}
            </small>
        </div>
    );
};
